import React from 'react';
import working from './img/working.png'
import RightButtons from './rightButtons';
class Tarifs extends React.Component {

    constructor(props) {
        super(props)
        this.state = { waiting:false }
    }

    resync() {
        this.setState({waiting:true})
        const me = this
        this.props.api.post({
            action:'get_devis',
            resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
            id:this.props.devis._id.$oid
        },
        ()=>{
            me.setState({waiting:false})
        })
    }

    renderAccount() {
        const devis = this.props.devis
        const warranty = devis.getWarranty()
        const frais = parseFloat(devis.params.frais)

        if ( devis.params.periodicite && warranty ) {
            const optionField = ( devis.params.periodicite=='M' )?'Z_MTMOP':'Z_MTAOP'
            return <table className="tarifs_account">
                <tbody>
                <tr><td><label>Formule&nbsp;:&nbsp;<span>{warranty.Z_FORM} : {warranty.ZZ0_LIBFOR}</span></label></td>
                <td><label>Périodicité&nbsp;:&nbsp;<span>{(devis.params.periodicite=='M')?'Mensuel':'Annuel'}</span></label></td>
                </tr>
                <tr>
                    
                {(devis.params.periodicite=='A')
                    ? <td><label>Annuel sans options&nbsp;:&nbsp;<span>{warranty.Z_MTAN}</span></label></td>
                    : <td><label>Mensuel sans options : Acompte&nbsp;:&nbsp;<span>{devis.fancyPrice(2*warranty.Z_MTMENS+frais)}</span> puis par mois : <span>{devis.fancyPrice(warranty.Z_MTMENS)}</span> à partir du 3ème mois.</label></td> 
                }   
                <td></td>
                </tr>
                <tr>{devis.getOptions().map( option => <td key={option.Z_CODOPT}><label>Option {option.ZZ0_LIBOPT}&nbsp;:&nbsp;<span>{devis.fancyPrice(option[optionField])}</span></label></td> )}</tr>
                </tbody>
            </table>
        }
        return <></>
    }

    render() {

        const devis = this.props.devis
        const hasSolly = devis.hasSollyTarifs()
        const solly = hasSolly ? devis.solly_tarifs : false

        console.log(solly)

        let frais = parseFloat(devis.params.frais)
        let rows = devis.params.warranties.map(
            row=>{
                const sollyMensuel = ( hasSolly && solly[row.Z_FORM].mensuel )? parseFloat(solly[row.Z_FORM].mensuel) : 0
                const sollyAcompte = ( hasSolly && solly[row.Z_FORM].acompte )? parseFloat(solly[row.Z_FORM].acompte) : 0
                return <React.Fragment key={row.Z_FORM}><tr>
                    <td className="ttitle" colSpan="3"><b>({row.Z_FORM})</b> {row.ZZ0_LIBFOR.replace('?','é')}</td>
                </tr><tr>
                    <td className="ttarif">{devis.fancyPrice(row.Z_MTAN)} € {hasSolly ? <span className="solly">{solly[row.Z_FORM].annuel ? <> / {devis.fancyPrice(solly[row.Z_FORM].annuel)} € <sup>4</sup></> : ''}</span> : ''}</td>
                    <td className="ttarif">{devis.fancyPrice((parseFloat(row.Z_MTMENS)+frais/12))} €
                    {hasSolly ? <span className="solly">{solly[row.Z_FORM].mensuel ? <> / {devis.fancyPrice((sollyAcompte+11*sollyMensuel)/12)} € <sup>4</sup></> : ''}</span> : ''}
                    </td>
                    <td className="ttarif">{devis.fancyPrice(2*row.Z_MTMENS+frais)} €
                    {hasSolly ? <span className="solly">{solly[row.Z_FORM].mensuel ? <> / {devis.fancyPrice(sollyAcompte)} € <sup>4</sup></> : ''}</span> : ''}
                    </td>
                    <td className="ttarif">{devis.fancyPrice(row.Z_MTMENS)} €
                    {hasSolly ? <span className="solly">{solly[row.Z_FORM].mensuel ? <> / {devis.fancyPrice(sollyMensuel)} € <sup>4</sup></> : ''}</span> : ''}
                    </td>
                </tr>
                </React.Fragment>
            }
        )

        return <React.Fragment>
            {this.renderAccount()}
            { this.props.devis.synchronized ? ''
            : <a onClick={this.resync.bind(this)}><img className="working" src={working}/> Ce dossier est en cours de modification. Cliquer ici pour re-contacter xenassur et éditer un nouveau devis</a> }
            <p className="details_head">
               <label>Montant des frais de dossier</label> : {frais} €.
            </p>
            <p className="solly">
            {( devis.solly_validated < 0 ) ? <><b>Erreur Solly - </b> {devis.solly_error}</> : ''}
            </p>
            <div className={this.state.waiting ? 'details waiting' : 'details'}>
            <table className="tarifs">
                <thead>
                    <tr><th colSpan="4" className="tarifs_head">Tableau des tarifs sans options.</th></tr>
                    <tr><th>Annuel</th><th>Mensuel lissé<sup>(1)</sup></th><th>Mensuel acompte<sup>(2)</sup></th><th>Mensuel<sup>(3)</sup></th></tr>
                </thead>
                <tbody>
                    {rows}
                    <tr><td colSpan="3">
                    <ul>
                        <li><b>(1) Mensuel lissé :</b> coût moyen par mois si périodicité mensuelle</li>
                        <li><b>(2) Mensuel acompte :</b> acompte si périodicité mensuelle : frais + 2 premiers mois (frais + premier mois pour Solly)</li>
                        <li><b>(3) Mensuel :</b> prix mensuel à partir du 3ème mois (2ème mois pour Solly)</li>
                        {hasSolly ? <li><span className="solly"><b>(4) Tarifs Solly Azar</b></span></li> : ''}
                    </ul>
                    </td></tr>
                </tbody>
            </table>
            <RightButtons {...this.props}/>
        </div>
        </React.Fragment>
    }
}

export default Tarifs;